import { useTheme } from '@mui/material';
import { ROUTES } from '../../constants/routes';
import { PageHeader } from '../layout/PageHeader';
import { ContentWrapper } from '../layout/styled';
import { SubmitedTimesheeetsTable } from './components/SubmitedTimesheeetsTable';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

export const OpManagerSubmittedTimesheets = () => {
  const { colors } = useTheme();
  const isSmallScreen = useAtomValue(isSmallScreenState);

  return (
    <>
      <PageHeader
        title='Submitted Timesheets'
        description=''
        breadcrumbs={[
          {
            title: 'All timesheet',
            url: `/${ROUTES.OP_MANAGER_ALL_TIMESHEETS}`,
            color: colors.textAccent.default,
          },
          {
            title: 'Submitted Timesheets',
          },
        ]}
      />
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <SubmitedTimesheeetsTable />
      </ContentWrapper>
    </>
  );
};
